/** Company profile page accent — keep in sync across header, tabs, reviews, pagination. */
export const COMPANY_BRAND_ORANGE = '#FF9C28';
export const COMPANY_BRAND_ON_ORANGE = '#331e00';
